import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import type { IDeskingActivity } from '../types';
import { getAllRoutes } from '../utils/routes';

import { dealerSelectors } from '@makemydeal/dr-shared-store';
import { ActivityRouteContainer, ConditionalProfiler } from '@makemydeal/dr-dash-components';
import InterstateDeskingActivity from './DeskingActivity.interstate';
import BaseDealActivity from './baseDealActivity/BaseDealActivity.interstate';

const Root = (props: IDeskingActivity) => {
    const { root } = getAllRoutes(props.baseRoute);
    const isBaseDealer = useSelector(dealerSelectors.isBaseDealExperience);

    const getRootComponent = () => {
        if (isBaseDealer) {
            return BaseDealActivity;
        }
        return InterstateDeskingActivity;
    };

    return (
        <ActivityRouteContainer data-testid="activities-desking-container" className="activities-desking">
            <ConditionalProfiler id="desking-activity">
                <Route path={root} component={getRootComponent()} />
            </ConditionalProfiler>
        </ActivityRouteContainer>
    );
};

Root.displayName = 'DeskingActivity';

export default Root;
